import { render, staticRenderFns } from "./ProjectsHeader.vue?vue&type=template&id=1567978e&"
import script from "./ProjectsHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProjectsHeader.vue"
export default component.exports